/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const postLoginV2Errors = {
    ERROR: 'error', // incorrect username or password
    UNKNOWN_USER: 'unknown username', // incorrect username or password
    LOCKOUT: 'lockout', // account is locked out
    RECAPTCHA_CHALLENGE_REQUIRED: 'additional challenge required', // recaptcha v2 fallback required
    RECAPTCHA_CHALLENGE_FAILED: 'challenge failed', // recaptcha challenge failed
} as const;

export const postMfaTokenErrors = {
    MFA_REJECTED: 'MFA_REJECTED', // incorrect MFA code
    MFA_ERROR_CODE: 'MFA_ERROR_CODE', // incorrect MFA code
    INVALID_AUTH_TOKEN: 'invalid auth token', // incorrect MFA code
} as const;

// export const postRequestPasswordResetErrors = {
//     CHALLENGE_FAILED: 'challenge failed', // challenge failed
//     CHALLENGE_REQUIRED: 'additional challenge required', // additional challenge required
//     ERROR: 'error', // usually means user not found
// } as const;

export const postApplyNewPasswordErrors = {
    FAILED_TO_RESET: 'could not reset password, please try again', // failed to reset password
    LOCKOUT: 'password reset request was sent recently; try again later', // tried too many times
} as const;

export const postAccountRegistrationErrors = {
    INVALID_CELL_PHONE: 'invalid cellphone', // invalid cellphone
    RECAPTCHA_CHALLENGE_REQUIRED: 'additional challenge required', // additional challenge required
    RECAPTCHA_CHALLENGE_FAILED: 'challenge failed', // challenge failed
    EXISTING_ACCOUNT: 'An account already exists for this email address', // account already exists
    LOCKOUT: 'lockout', // resend limit reached
} as const;

export const putAccountEmailValidationErrors = {
    INVALID_CODE: 'invalid registration email code', // invalid code
} as const;

export const postSetPasswordErrors = {} as const;
